export default "__VITE_ASSET__b7e7d664__"